import { useConfigContext } from '../../../contexts/ConfigContext/ConfigContextProvider'
import './UserProfileHeader.css'

export default function UserProfileHeader() {
   const { jsonTexts } = useConfigContext()
   const text = jsonTexts?.miCuenta?.title
   return (
      <header className='UserProfile-header-container'>
         <h2 className='UserProfile-header-text'>{text}</h2>
      </header>
   )
}
